export enum FeesType {
    None = 0,
    percentage = 1,  
    Amount = 2
}
